import type { Path } from 'react-hook-form';
import type { SharedUnionFieldsNested } from '../../types/sharedUnionFieldsNested';
import { isObject } from '../utilFunctions';

export type FormName<O extends object> = Path<SharedUnionFieldsNested<O>>;
export type FormNames<O extends object> = { [fn in FormName<O>]: fn };

export const getFormNames = <T extends object>(
    defaultValues: T
): FormNames<T> => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.entries(defaultValues).reduce(
        (result, [key, value]) => {
            result[key] = key;

            if (isObject(value)) {
                const nestedFormNames = getFormNames(value);
                Object.keys(nestedFormNames).forEach((nestedKey) => {
                    result[`${key}.${nestedKey}`] = `${key}.${nestedKey}`;
                });
            }

            return result;
        },
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {} as Record<string, string>
    ) as FormNames<T>;
};
